import Swiper from '../../node_modules/swiper/js/swiper.min.js';

let block = false;

const init = () => {
	block = document.querySelector('.b-video-slider');
	if (!block) return false;
	sliderRun();
}

const sliderRun = () => {
	new Swiper(block.querySelector('.b-video-slider__container'), {
		slidesPerView: 1,
		spaceBetween: 16,
		navigation: {
			nextEl: block.querySelector('.b-sliderArrows-btn_next'),
			prevEl: block.querySelector('.b-sliderArrows-btn_prev')
		},
	});
}

document.addEventListener('DOMContentLoaded', init)
